import axios, { AxiosResponse } from 'axios'
import moment from 'moment'

import { RequestGENERIC, RequestREAD } from 'services/Instances'
import { ApiType, getApiURL } from 'services/Instances/configuration'
import { readApiClient } from 'services/Instances/read'
import { Auth } from 'services/Instances/types'
import { ITypeUpload } from 'utils/types'

type TManuais = 'Manual-de-Operacao-do-Usuario-Fornecedor.pdf' | 'Orientacao-Geral-Documentacao-Mensal.pdf' | 'Orientacao-Geral-Movimentacao-de-colaboradores.pdf' | 'Manual-de-Operacao-do-Usuario-Contraparte.pdf'

export const ManuaisFornecedorService = () => {
  const getManual = async (manual: TManuais): Promise<AxiosResponse<string>> =>
    await RequestREAD.get(`ArquivoEstatico/${manual}`)

  return {
    getManual,
  }
}

export default {
  GetEvidencia: async (
    idDocPai: number | string,
    idTipoAnexoDoc: number
  ): Promise<AxiosResponse<ITypeUpload[]>> =>
    await RequestREAD.get(
      'AnexarDocEvidencia/' + idDocPai + '/' + idTipoAnexoDoc
    ),
  VerifyToken: async (objRequest: IRequestValidToken): Promise<AxiosResponse> =>
    await RequestGENERIC.post('VerificarValidacaoToken', objRequest)
}


export interface IRequestValidToken {
  token: string
}

export async function HandleToken() {
  let auth = null;
  const rememberMe = eval(window.sessionStorage.getItem('csn-session'))
  const refresh = window.localStorage.getItem('csn-rtk')
  const token = window.localStorage.getItem('csn-tk')
  const isCSN = eval(window.localStorage.getItem('isCSN'))
  const tempLocal = window.localStorage.getItem('persist:root')
  const ref = JSON.parse(tempLocal)
  if (ref?.auth)
    auth = JSON.parse(ref?.auth);

  if (token) {
    if (rememberMe || isCSN) {
      HandleRefreshToken(refresh, auth, token)
        .then((refreshToken: any) => {
          if (refreshToken) {
            return `Bearer ${refreshToken}`
          }

          return null
        }).catch(error => {
          // window.localStorage.clear()
          // window.location.reload()

          // return null
        })
    }

    return `Bearer ${token}`
  }

  return null
}

export const CheckApiRead = (NmMatricula: string, isFornecedor?: number) => {
  const pathCSN = `/UsuarioCsn/Matricula?matricula=${NmMatricula.trim()}&likeSearch=false`
  const pathFornecedor = `UsuarioFornecedor/Fornecedor/${isFornecedor}`
  const path = isFornecedor ? pathFornecedor : pathCSN;
  return new Promise<boolean>((res, rej) => {
    RequestREAD.get(`${getApiURL(ApiType.Read)}${path}`).then(() => res(true)).catch(() => res(false))
  });
}

const HandleRefreshToken = (refreshToken: string, auth: Auth, token: string): Promise<string> => {
  const csnToken = window.localStorage.getItem('csn-token')

  axios.post(`${getApiURL(ApiType.Login)}RefreshToken`,
    {
      refreshToken,
      email: auth.user.TxEmail,
      token: csnToken ?? token,
      perfilUsuarioId: auth.user.PerfilUsuarioId.toString()
    })
    .then(response => {
      if (response.status !== 200) {
        throw new Error(response.data.mensagem || 'Não foi possivel validar token')
      }

      // window.localStorage.setItem('csn-time', new Date().toString())
      window.localStorage.setItem('csn-tk', response.data.token)
      window.localStorage.setItem('csn-token', response.data.token)

      return response.data.token
    })
    .catch(() => {
      // window.localStorage.clear()
      // window.location.reload()

      // return ''
    })

  return Promise.resolve('')
}
